import styled from "styled-components";

export const Container = styled.div(({ center, alone }) => ({
  maxWidth: "100%",
  width: "100%",
  height: alone ? "auto" : "70vh",
  minHeight: alone ? "0" : "90vh",
  margin: alone ? "0 10px 5px 20px" : 0,
  display: "flex",
  justifyContent: center ? "center" : "unset",
  alignItems: center ? "center" : "unset",
}));
